import React, { useEffect, useState } from 'react';
import { GetRequest } from 'components/common/index.js';
import SubscriptionCard from 'components/payment/SubscriptionCard.jsx';

// Every subscription the customer holds, one card each. A customer can hold a website plan
// and a Dielines API plan side by side; this used to render a single card from a single
// subscription object, so the second was invisible and unmanageable from the account page.
const MySubscription = ({ link_to_manage }) => {

  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);

  const getMySubscription = () => {
    GetRequest({
      url: '/charge/my-subscription',
      callback: (data) => {
        setLoading( () => false );
        setSubscriptions( () => (data && Array.isArray(data.subscriptions)) ? data.subscriptions : [] );
      }
    })
  }

  useEffect( getMySubscription, []);

  if(loading) {
    return (
      <div className="subscription-card subscription-card-skeleton" aria-busy="true" aria-label={t('sign_up.fetching_subscription_please_wait')}>
        <div className="subscription-card-icon" aria-hidden="true">
          <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" fill="none">
            <rect x="10" y="26" width="50" height="36" rx="5" fill="#ffffff" />
            <rect x="10" y="32" width="50" height="5" fill="rgba(0,0,0,0.18)" />
            <rect x="16" y="44" width="10" height="7" rx="1.5" fill="#eb5424" opacity="0.7" />
            <circle cx="32" cy="55" r="1.6" fill="#eb5424" opacity="0.55" />
            <circle cx="37" cy="55" r="1.6" fill="#eb5424" opacity="0.55" />
            <circle cx="42" cy="55" r="1.6" fill="#eb5424" opacity="0.55" />
            <circle cx="47" cy="55" r="1.6" fill="#eb5424" opacity="0.55" />
            <circle cx="60" cy="22" r="14" fill="#ffffff" />
            <path d="M 60 14 A 8 8 0 1 1 52 22" fill="none" stroke="#eb5424" strokeWidth="3.5" strokeLinecap="round" />
            <polygon points="52,12 47,21 57,21" fill="#eb5424" />
          </svg>
        </div>
        <div className="subscription-card-body">
          <div className="subscription-skeleton-row subscription-skeleton-row-between">
            <div>
              <div className="subscription-skeleton-line subscription-skeleton-line-label" />
              <div className="subscription-skeleton-line subscription-skeleton-line-plan" />
            </div>
            <div className="subscription-skeleton-line subscription-skeleton-line-price" />
          </div>
          <div className="subscription-skeleton-divider" />
          <div className="subscription-skeleton-row">
            <div className="subscription-skeleton-line subscription-skeleton-line-meta" />
            <div className="subscription-skeleton-line subscription-skeleton-line-meta" />
          </div>
        </div>
      </div>
    )
  }

  if(subscriptions.length === 0) {
    return ''
  }

  return (
    <>
      {subscriptions.map((subscription) => (
        <SubscriptionCard
          key={subscription.id}
          subscription={subscription}
          link_to_manage={link_to_manage}
          onChanged={getMySubscription}
        />
      ))}
    </>
  )
}

export default MySubscription;
